import type { UpdateDocuSignRecipient } from '@urbanx/agx.docusign.client'
import type { ManualDocuSignUpdateRecipientDetails } from '@urbanx/agx.support.client'

type RecipientUpdateStatus = 'signed' | 'completed'

export const buildRecipientUpdatePayload = (
  recipient: ManualDocuSignUpdateRecipientDetails,
  status: RecipientUpdateStatus,
  signedAt: Date
): UpdateDocuSignRecipient => ({
  recipientId: recipient.recipientUniqueIdentifier,
  status,
  signedDateTime: recipient.signedDateTime ?? signedAt,
  deliveredDateTime: recipient.deliveredDateTime,
  sentDateTime: recipient.sentDateTime,
})
